import React from "react";

// utils
import { useLanguage } from "../../utils/languageHelpers";

// configs
import languageScripts from "../../config/languageScripts";

export default ({ children }) => {
  const { language } = useLanguage();

  // English - just return as-is
  if (language === "en") return <>{children}</>;

  // Look up translation
  const entry = languageScripts[children];
  if (!entry) return <>{children}</>;

  // Get translation with fallback: cn → tw → English
  const text = entry[language] || entry.tw || children;

  return <>{text}</>;
};
